import config from '../config';
const allowTrackInfoKeys = ['category', 'subcategory', 'dealer', 'site'];
const defaultPageVars = {};

export default {
  /**
   *
   * @param {*} golbal 全局设置
   *  @param {*} tempPGVars 临时的变量
   */
  trackPageView(trackVars, tempPGVars) {
    tempPGVars = tempPGVars || {};
    trackVars = trackVars || {};
    // 设置全局变量
    for (let keyIndex = 0; keyIndex < allowTrackInfoKeys.length; keyIndex++) {
      const key = allowTrackInfoKeys[keyIndex];
      if (trackVars[key]) {
        window.pvTrack[key] = trackVars[key];
      } else {
        window.pvTrack[key] = config.pvTrackData[key] || window.pvTrack[key];
      }
    }
    //  设置页面变量
    window.pvTrack.pageVars = window.pvTrack.pageVars || {};
    for (const key in defaultPageVars) {
      window.pvTrack.pageVars[key] = defaultPageVars[key];
    }
    // 设置页面临时变量
    for (const key in tempPGVars) {
      window.pvTrack.pageVars[key] = tempPGVars[key];
    }
    // 上报埋点
    window.trackPageView();
    if (!window.pvTrack.pageVars) {
      return;
    }
    //  删除临时变量
    for (const key in tempPGVars) {
      delete window.pvTrack.pageVars[key];
    }
  },
  /**
   * 设置全局默认的数据
   * @param {*} trackInfo
   */
  setDefaultTrackVar(trackInfo) {
    if (!trackInfo) {
      return;
    }
    for (let keyIndex = 0; keyIndex < allowTrackInfoKeys.length; keyIndex++) {
      const key = allowTrackInfoKeys[keyIndex];
      if (trackInfo[key]) {
        window.pvTrack[key] = trackInfo[key];
      }
    }
  },
  /**
   * 设置默认的页面变量信息
   */
  setDefaultPageVar(vars) {
    if (!vars) {
      return;
    }
    for (const key in vars) {
      if (!vars[key]) {
        continue;
      }
      defaultPageVars[key] = vars[key];
    }
  },
};
